module.exports = __webpack_public_path__ + "img/undraw_cancel_re_pkdm.134b8b6c.svg";